import LoadingSpinner from "../../LoadingSpinner";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {
  getBehalfOf,
  getUserById,
  getUsernameById,
} from "../../../api/systemUserApi";
import SearchDropdown from "../../input/SearchDropdown";
import Dropdown from "../../input/Dropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getFieldValuesByTableAndId,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import Button from "../../input/Button";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import Grid from "../../Grid";
import { UserCustomerValidation } from "../../validations/UserCustomerCreation";
import { stakeholderById } from "../../../api/stakeholderapi";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../renderer/StyleRenderer";
import { toast } from "react-toastify";
import { shiftUserFindByUserId } from "../../../api/shiftApi";
import {
  findUserCustomerByUscUserIdAndUscStakeholderAndUscActive,
  findUserCustomerByUserAndStakeholderAndActive,
  findUserCustomerByuserAndstakeholderAndactive,
  getShippersByCustomer,
} from "../../../api/UserCustomerApi";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const UserCustomerForm = forwardRef(
  ({ dropdown, isLoading, currentValues, editMode }, ref) => {
    const [user, setUser] = useState("");

    const [currentErrors, setCurrentErrors] = useState({});
    const [currentUserCustomer, setCurrentUserCustomer] = useState({});

    const [userCustomer, setUserCustomer] = useState([]);
    const [deletedList, setDeletedList] = useState([]);
    const [deletedUser, setDeletedUser] = useState([]);

    const [stakeholderType, setStakeholderType] = useState(false);
    const [selectedStakeholder, setSelectedStakeholder] = useState([]);

    //counter
    const [userCustomerCount, setUserCustomerCount] = useState(2);

    // flags
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [userFieldReset, setUserFieldReset] = useState(false);
    const [stkFieldReset, setStkFieldReset] = useState(false);
    const [customerFieldReset, setCustomerFieldReset] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [currentUserEdit, setCurrentUserEdit] = useState(false);

    //dropdown
    const [stakeTypeOptions, setStakeTypeOptions] = useState([]);
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [requestCustomer, setRequestCustomer] = useState("");
    const stakeholderRef = useRef(null);

    const [yesnoOptions, setYesnoOptions] = useState([]);

    const [userCustomerData, setUserCustomerData] = useState(
      editMode
        ? {
            uscUserId: currentValues[0].uscUserId,
            uscStkType: "",
            uscStakeholder: "",
            uscStatus: 2,
            uscActive: 1,
            uscRequestApproval: 1,
          }
        : {
            uscCode: "",
            uscReferance: "",
            uscCompany: "",
            uscUserId: "",
            uscStkType: "",
            uscStakeholder: "",
            uscStakeholderId: "",
            stakeholder: "",
            name: "",
            uscStatus: 2,
            uscActive: 1,
            uscShipperCustomer: "",
            uscRequestApproval: 1,
          },
    );

    useEffect(() => {
      (async () => {
        //new
        const {
          active,
          status,
          stakeholder_type: stakeholderTypeOpt,
          yesno: yesNoData,
        } = await getBulkDropdownData([
          { key: "active" },
          { key: "status" },
          { key: "stakeholder_type" },
          { key: "yesno" },
        ]);

        setActiveOptions(active);
        setStatusOptions(status);
        setStakeTypeOptions(stakeholderTypeOpt);
        setYesnoOptions(yesNoData);
      })();
    }, []);

    useEffect(() => {
      if (Object.keys(currentUserCustomer).length > 0) {
        setUserCustomerData({
          ...currentUserCustomer,
          uscStakeholder: currentUserCustomer.uscStakeholderId
            ? currentUserCustomer.uscStakeholderId
            : currentUserCustomer.uscStakeholder,
          uscStakeholderId: currentUserCustomer.uscStakeholderId
            ? currentUserCustomer.uscStakeholderId
            : currentUserCustomer.uscStakeholder,
        });

        const typeId = currentUserCustomer.uscStkType;
        setStakeholderType(typeId);

        if (currentUserCustomer.uscShipperCustomer) {
          setRequestCustomer(currentUserCustomer.uscShipperCustomer);
        }

        setCurrentUserEdit(true);
      }
    }, [currentUserCustomer]);

    useEffect(() => {
      (async () => {
        if (editMode && currentValues) {
          let currentUserCustomers = [];
          let id = 2;
          for (let currentValue of currentValues) {
            const uscStatusValue = await getTextByValueAndKey(
              "status",
              currentValue.uscStatus,
            );
            const uscActiveValue = await getTextByValueAndKey(
              "active",
              currentValue.uscActive,
            );
            const username = await getUsernameById(currentValue.uscUserId);
            const typTypeValue = await getTextByValueAndKey(
              "stakeholder_type",
              currentValue.uscStkType,
            );

            const uscRequestApproval = await getTextByValueAndKey(
              "yesno",
              currentValue.uscRequestApproval,
            );

            const stakeholder = await getFieldValuesByTableAndId({
              tableName: "masterdata.tms_m_stakeholder",
              primaryKey: "stk_id",
              fieldNames: "stk_name",
              ids: currentValue.uscStakeholderId,
            });

            const stakeholderName = stakeholder[0].field1;

            const shiperCustomer = await getFieldValuesByTableAndId({
              tableName: "masterdata.tms_m_stakeholder",
              primaryKey: "stk_id",
              fieldNames: "stk_name",
              ids: currentValue.uscShipperCustomer,
            });

            const shiperCustomerName = shiperCustomer[0].field1;

            currentUserCustomers.push({
              ...currentValue,
              name: username,
              active: uscActiveValue,
              status: uscStatusValue,
              stkType: typTypeValue,
              stakeholder: stakeholderName,
              uscShipperCustomerName: shiperCustomerName,
              rqstApproval: uscRequestApproval,
              id,
            });

            ++id;
          }
          setUserCustomerCount(id);
          setUserCustomer(currentUserCustomers);
          setUserCustomerData((prevState) => ({
            ...prevState,
            name: currentUserCustomers[0].name,
          }));
        }
      })();
    }, [editMode, currentValues]);

    const onAddClick = async () => {
      setIsAddLoading(true);

        const currentUserId = userCustomerData.uscUserId;
        const currentStkId = userCustomerData.uscStakeholder;
        const currentCustId = userCustomerData.uscShipperCustomer || "";

        const isDuplicate = userCustomer.some((row) => {
            const rowStkId = row.uscStakeholderId || row.uscStakeholder;
            const rowCustId = row.uscShipperCustomer || row.uscShipperCustomerId || "";

            return (
                String(row.uscUserId) === String(currentUserId) &&
                String(rowStkId) === String(currentStkId) &&
                String(rowCustId) === String(currentCustId) &&
                row.id !== userCustomerData.id
            );
        });

        if (isDuplicate) {
            toast.error("This record is already in the grid!", { containerId: "Main" });
            setIsAddLoading(false);
            return;
        }

      const userCustomerErrors = UserCustomerValidation({
        ...userCustomerData,
      });

      const shipperOrStakeholderId = userCustomerData.uscStakeholderId ?? userCustomerData.uscStakeholder;
      const customerId = userCustomerData.uscShipperCustomer ?? "";

      const gridDuplicate = userCustomer.some((row) => {
        const rowStakeholderId = row.uscStakeholderId ?? row.uscStakeholder;
        const rowCustomerId = row.uscShipperCustomer ?? row.uscShipperCustomerId ?? "";

        return (
            String(row.uscUserId) === String(userCustomerData.uscUserId) &&
            String(rowStakeholderId) === String(shipperOrStakeholderId) &&
            String(rowCustomerId) === String(customerId) &&
            row.id !== userCustomerData.id
        );
      });

      if (gridDuplicate) {
        toast.error("This record is already in the grid!", { containerId: "Main" });
        setIsAddLoading(false);
        return;
      }

      if (Object.keys(userCustomerErrors).length === 0) {
        const response =
          await findUserCustomerByUserAndStakeholderAndActive(userCustomerData);

        if (!userCustomerData.id && response !== "") {
          toast.error(
            "There was an error adding user customer already exists!",
            { autoClose: 5000, containerId: "Main" },
          );
        } else {
          const uscStatusValue = await getTextByValueAndKey(
            "status",
            userCustomerData.uscStatus,
          );
          const uscActiveValue = await getTextByValueAndKey(
            "active",
            userCustomerData.uscActive,
          );
          const username = await getUsernameById(userCustomerData.uscUserId);
          const typTypeValue = await getTextByValueAndKey(
            "stakeholder_type",
            userCustomerData.uscStkType,
          );

          const uscRequestApproval = await getTextByValueAndKey(
            "yesno",
            userCustomerData.uscRequestApproval,
          );

          const stakeholder = await getFieldValuesByTableAndId({
            tableName: "masterdata.tms_m_stakeholder",
            primaryKey: "stk_id",
            fieldNames: "stk_name",
            ids: userCustomerData.uscStakeholder,
          });

          const stakeholderName = stakeholder[0].field1;

          if (!userCustomerData.uscId) {
            if (!userCustomerData.id) {
              setUserCustomer((prevState) => [
                ...prevState,
                {
                  ...userCustomerData,
                  name: username,
                  active: uscActiveValue,
                  status: uscStatusValue,
                  stkType: typTypeValue,
                  stakeholder: stakeholderName,
                  rqstApproval: uscRequestApproval,
                  id: userCustomerCount,
                },
              ]);
              setUserCustomerCount((prevState) => ++prevState);
            } else {
              setUserCustomer((prevState) =>
                prevState.filter((item) => item.id !== userCustomerData.id),
              );
              setUserCustomer((prevState) => [
                ...prevState,
                {
                  ...userCustomerData,
                  name: username,
                  active: uscActiveValue,
                  status: uscStatusValue,
                  stkType: typTypeValue,
                  stakeholder: stakeholderName,
                  rqstApproval: uscRequestApproval,
                },
              ]);
            }
          } else {
            setUserCustomer((prevState) =>
              prevState.filter((item) => item.uscId !== userCustomerData.uscId),
            );
            setUserCustomer((prevState) => [
              ...prevState,
              {
                ...userCustomerData,
                name: username,
                active: uscActiveValue,
                status: uscStatusValue,
                stkType: typTypeValue,
                stakeholder: stakeholderName,
                rqstApproval: uscRequestApproval,
                modified: true,
              },
            ]);
          }
          setRequestCustomer("");
          setUserCustomerData((prev) => ({
            ...prev,
            uscStakeholder: null,
          }));
          setCustomerFieldReset(true);
          setButtonClicked(true);
        }

        setCurrentErrors(userCustomerErrors);
        setIsAddLoading(false);
      } else {
        setCurrentErrors(userCustomerErrors);
        setIsAddLoading(false);
      }
    };

    useEffect(() => {
      if (buttonClicked) {
        if (editMode) {
          setUserCustomerData({
            uscCode: "",
            uscReferance: "",
            uscCompany: "",
            uscUserId: currentValues[0].uscUserId,
            uscStkType: "",
            uscStakeholder: "",
            uscStatus: 2,
            uscActive: 1,
            uscShipperCustomer: "",
            uscRequestApproval: 1,
          });
        } else {
          setUserCustomerData({
            uscCode: "",
            uscReferance: "",
            uscCompany: "",
            uscUserId: "",
            name: "",
            uscStkType: "",
            uscStakeholder: "",
            uscStatus: 2,
            uscActive: 1,
            uscShipperCustomer: "",
            uscRequestApproval: 1,
          });
          setUserFieldReset(true);
        }

        setButtonClicked(false);
        setSearchFieldReset(true);
        setStkFieldReset(true);
        setCurrentUserCustomer({});
        // setCurrentUserEdit(false);
        setStakeholderType(false);
        setRequestCustomer("");
        setCustomerFieldReset(true);
      }
    }, [buttonClicked]);

    useEffect(() => {
      (async () => {
        const selectedStakeholder = await getTextByValueAndKey(
          "stakeholder_type",
          stakeholderType,
        );
        setSelectedStakeholder(selectedStakeholder);
      })();
    }, [stakeholderType]);

      const onAddAllShippers = async () => {
          if (!requestCustomer || !userCustomerData.uscUserId) {
              toast.error("Please select both User and Customer.", { containerId: "Main" });
              return;
          }

          setIsAddLoading(true);

          try {
              const shippers = await getShippersByCustomer(requestCustomer);
              if (!shippers?.length) {
                  toast.info("No shippers found.", { containerId: "Main" });
                  setIsAddLoading(false);
                  return;
              }

              const notInGrid = shippers.filter((s) => {
                  return !userCustomer.some((row) => {
                      const rowStkId = row.uscStakeholderId || row.uscStakeholder;
                      const rowCustId = row.uscShipperCustomer || row.uscShipperCustomerId || "";
                      return (
                          String(row.uscUserId) === String(userCustomerData.uscUserId) &&
                          String(rowStkId) === String(s.shipperId) &&
                          String(rowCustId) === String(requestCustomer)
                      );
                  });
              });

              if (notInGrid.length === 0) {
                  toast.info("All shippers are already in the grid.", { containerId: "Main" });
                  setIsAddLoading(false);
                  return;
              }

              const dbChecks = await Promise.all(
                  notInGrid.map(async (s) => {
                      const checkData = {
                          ...userCustomerData,
                          uscStkType: 2,
                          uscStakeholder: s.shipperId,
                          uscShipperCustomer: requestCustomer,
                      };
                      const response = await findUserCustomerByUserAndStakeholderAndActive(checkData);
                      return response === "" ? s : null;
                  })
              );

              const finalToAdd = dbChecks.filter((s) => s !== null);

              if (finalToAdd.length === 0) {
                  toast.error("All remaining shippers already exist in the system!", {
                      containerId: "Main",
                  });
                  setIsAddLoading(false);
                  return;
              }

              const username = await getUsernameById(userCustomerData.uscUserId);
              const activeText = await getTextByValueAndKey("active", 1);
              const statusText = await getTextByValueAndKey("status", 2);
              const approvalText = await getTextByValueAndKey("yesno", userCustomerData.uscRequestApproval);

              const bulkRows = finalToAdd.map((s, index) => ({
                  ...userCustomerData,
                  uscStkType: 2,
                  uscStakeholder: s.shipperId,
                  uscStakeholderId: s.shipperId,
                  uscShipperCustomer: requestCustomer,
                  uscShipperCustomerId: requestCustomer,
                  stakeholder: s.shipperName,
                  name: username,
                  active: activeText,
                  status: statusText,
                  stkType: "Shipper",
                  rqstApproval: approvalText,
                  id: `bulk-${s.shipperId}-${Date.now()}-${index}`,
              }));

              setUserCustomer((prev) => [...prev, ...bulkRows]);
              setUserCustomerCount((prev) => prev + bulkRows.length);

              const totalFound = shippers.length;
              const addedCount = bulkRows.length;
              const skippedCount = totalFound - addedCount;

              toast.success(`Added ${addedCount} new shippers.`, { containerId: "Main" });
              if (skippedCount > 0) {
                  toast.info(`${skippedCount} shippers skipped (already in Grid or System).`, {
                      containerId: "Main",
                  });
              }

          } catch (error) {
              toast.error("An error occurred while fetching data.");
          } finally {
              setIsAddLoading(false);
          }
      };

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          const updateState = {
            modified: [],
            created: [],
            unmodified: [],
            deleted: deletedList,
            deleteRelatedUser: deletedUser,
          };
          userCustomer.forEach((usc) => {
            if (usc.uscId && usc.uscId !== null) {
              if (usc.modified) {
                updateState.modified.push(usc);
              } else {
                updateState.unmodified.push(usc);
              }
            } else {
              updateState.created.push(usc);
            }
          });
          return updateState;
        } else {
          return userCustomer;
        }
      },

      resetForm: () => {
        setButtonClicked(true);
        setUserCustomer([]);
        setStakeholderType(false);
        setRequestCustomer("");
      },
    }));
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <div className="field">
                <SearchDropdown
                  key={1}
                  threshold={1}
                  required={true}
                  multiGrid={true}
                  multiGridCurrentValue={userCustomerData.name}
                  editMode={editMode}
                  reset={userFieldReset}
                  setReset={setUserFieldReset}
                  api={getBehalfOf}
                  apiDependency={{
                    customer: null,
                    shipper: null,
                  }}
                  onResultSelect={(data) =>
                    setUserCustomerData((prevState) => ({
                      ...prevState,
                      uscUserId: data,
                    }))
                  }
                  error={currentErrors.uscUserId}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { uscUserId: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label="User"
                  disabled={editMode}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Stakeholder Type"
                  error={currentErrors.uscStkType}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { uscStkType: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Stakeholder Type"
                  options={stakeTypeOptions}
                  style={{ height: "20px" }}
                  value={userCustomerData.uscStkType}
                  onChange={(e, data) => {
                    setUserCustomerData((prevState) => ({
                      ...prevState,
                      uscStkType: data.value,
                    }));
                    setStakeholderType(data.value);
                    setStkFieldReset(true);
                  }}
                />
                {(stakeholderType === 2 ||
                  userCustomerData.uscShipperCustomer) && (
                  <SearchDropdown
                    key={1}
                    required={true}
                    editMode={editMode}
                    reset={customerFieldReset}
                    setReset={setCustomerFieldReset}
                    clearable={true}
                    onResultSelect={(data) => {
                      setRequestCustomer(data);
                      setUserCustomerData((prevState) => ({
                        ...prevState,
                        uscShipperCustomer: data,
                      }));
                    }}
                    api={getOtherRefSearchDropdown}
                    apiDependency={{
                      type: "stakeholder_type",
                      value: "Customer",
                    }}
                    multiGrid={true}
                    multiGridCurrentValue={
                      userCustomerData.uscShipperCustomerName
                    }
                    // value={userCustomerData.uscShipperCustomer}
                    label="Customer"
                    onClear={() => {
                      setRequestCustomer("");
                      setUserCustomerData((prevState) => ({
                        ...prevState,
                        uscStakeholder: null,
                        uscShipperCustomer: "",
                      }));
                      stakeholderRef.current.reset();
                    }}
                  />
                )}
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  ref={stakeholderRef}
                  required={true}
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={userCustomerData.stakeholder}
                  reset={stkFieldReset}
                  setReset={setStkFieldReset}
                  clearable={true}
                  onClear={() => {
                    setUserCustomerData((prevState) => ({
                      ...prevState,
                      uscStakeholder: null,
                    }));
                  }}
                  onResultSelect={(data) =>
                    setUserCustomerData((prevState) => ({
                      ...prevState,
                      uscStakeholder: data,
                    }))
                  }
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    stakeholderType !== 2
                      ? {
                          type: "stakeholder_type",
                          value: selectedStakeholder,
                        }
                      : {
                          type: "stakeholder_type",
                          value: selectedStakeholder,
                          param2: requestCustomer ? requestCustomer : "",
                        }
                  }
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: userCustomerData.uscStakeholder,
                  }}
                  error={currentErrors.uscStakeholder}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { uscStakeholder: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  label={
                    selectedStakeholder ? selectedStakeholder : "Stakeholder"
                  }
                  disabled={stakeholderType === 2 && requestCustomer === ""}
                />
                <Dropdown
                  required={true}
                  label="Request Approval"
                  error={currentErrors.uscRequestApproval}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { uscRequestApproval: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={yesnoOptions}
                  value={userCustomerData.uscRequestApproval}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setUserCustomerData((prevState) => ({
                      ...prevState,
                      uscRequestApproval: data.value,
                    }));
                  }}
                />
              </div>

              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.uscStatus}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { uscStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  style={{ height: "20px" }}
                  value={userCustomerData.uscStatus}
                  onChange={(e, data) => {
                    setUserCustomerData((prevState) => ({
                      ...prevState,
                      uscStatus: data.value,
                    }));
                  }}
                />
                {/* <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.uscActive}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { uscActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  style={{ height: "20px" }}
                  value={userCustomerData.uscActive}
                  onChange={(e, data) => {
                    setUserCustomerData((prevState) => ({
                      ...prevState,
                      uscActive: data.value,
                    }));
                  }}
                /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                {stakeholderType === 2 && requestCustomer && Object.keys(currentUserCustomer).length === 0 && (
                    <button
                        type="button"
                        className="ui white button"
                        onClick={onAddAllShippers}
                        disabled={isAddLoading}
                    >
                       ALL SHIPPERS
                    </button>
                )}
                <Button
                  template="addOrSave"
                  create={Object.keys(currentUserCustomer).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <Grid
                heading="User Customer"
                config={[
                  { headerName: "User", field: "name" },
                  { headerName: "Type", field: "stkType" },
                  {
                    headerName: "Stakeholder",
                    field: "stakeholder",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  { headerName: "Reuqst Approval", field: "rqstApproval" },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        setCurrentUserCustomer(params.data);
                      },
                      label: "Edit",
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        if (params.data.uscId && params.data.uscId !== null) {
                          setDeletedList((prevState) => [
                            ...prevState,
                            params.data.uscId,
                          ]);
                          setDeletedUser((prevState) => [
                            ...prevState,
                            params.data.uscUserId,
                          ]);
                        }
                        setUserCustomer((prevState) =>
                          prevState.filter(
                            (userCustomer) =>
                              userCustomer.id !== params.data.id,
                          ),
                        );
                      },
                      message:
                        "Are you sure you want to delete this User Customer?",
                      label: "Delete",
                      className: "ui red button",
                    }),
                  },
                ]}
                content={userCustomer}
              />
            </div>
          </form>
        )}
      </>
    );
  },
);
export default UserCustomerForm;
